<template>
    <div id="app">
        <router-view/>
    </div>
</template>

<script>
export default {
  name: 'app',
  computed: {
    alert () {
      return this.$store.state.alert
    }
  },
  watch: {
    $route (to, from) {
      // clear alert on location change
      this.$store.dispatch('alert/clear')
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue